import { useQuery } from '@tanstack/react-query';
import { fetchCustomers, type CustomersParams } from '@/lib/api';

export function useCustomers(params: CustomersParams = {}) {
  return useQuery({
    queryKey: ['customers', params],
    queryFn: () => fetchCustomers(params),
    placeholderData: (prev) => prev,
    staleTime: 10_000,
  });
}
